var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"centered":"","width":"80%","title":_vm.$t('edit_product_title'),"ok-text":_vm.$t('save_button'),"cancel-text":_vm.$t('cancel_button')},on:{"cancel":function($event){_vm.current = null},"ok":_vm.okHandler},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('transition',{attrs:{"name":"default-hide","mode":"out-in"}},[(_vm.current && _vm.productCopy)?_c('div',[_c('div',{staticClass:"flex flex-col md:flex-row md:gap-2"},[_c('text-input',{staticClass:"w-full",attrs:{"setup":{
            'func': _vm.modelSetter,
            'args': {
              'model': _vm.productCopy,
              'key': 'name',
              'prefix': 'product_'
            }
          }}}),_c('multi-currency-input',{staticClass:"w-full",attrs:{"setup":{
            'func': _vm.setPrice,
            'args': {
              'model': this,
              'key': 'productCopy',
              'options': _vm.currencyOptions(_vm.core.currencyList),
              'prefix': 'price_',
            }
          }}})],1),_c('textarea-input',{attrs:{"setup":{
          'func': _vm.modelSetter,
          'args': {
            'model': _vm.productCopy,
            'key': 'description',
            'prefix': 'product_'
          }
        }}}),_c('file-uploader-targets-input',{key:_vm.imgTemplate,attrs:{"setup":{
          'func': _vm.modelSetter,
          'args': {
            'model': _vm.productCopy,
            'key': 'image',
            'base-api-url': 'api.presscode.app/cabinet',
            'available-mime-types': ['image/png', 'image/jpeg'],
            'prefix': 'product_',
            'targetToUpload': function () {
              return {
                'target': 'target',
                'target_id': _vm.core.getTargetId()
              }
            },
          }
        }}})],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }